module.exports = __webpack_public_path__ + "img/cadet_7-7-2021.613b737c.jpg";